export const parseScappLocalDate = (value) => {
  if (value instanceof Date) return new Date(value.getTime());
  const localValue = String(value || '').replace(/(?:Z|[+-]\d{2}:?\d{2})$/, '');
  return new Date(localValue);
};
